module.exports = __webpack_public_path__ + "img/polar-base.e9fdbc63.jpg";